module.exports = __webpack_public_path__ + "static/ff-9c9e5da1c3e2a81c21be3fa3b0f1476e.jpg";